// extracted by mini-css-extract-plugin
export default {"avatar-wrapper":"Avatar_avatar-wrapper__ApQqi","avatar-wrapper__user-snippet":"Avatar_avatar-wrapper__user-snippet__hS5QB"};